module.exports = __webpack_public_path__ + "static/media/mech-engine.33f3ec22.ogg";